import $ from 'static/script/libs/jquery';
import defineComponent from 'flight';

function Logger() {
    this.logInfo = function (e, msg) {
        this._log(e, msg, 'js-info');
    };

    this.logError = function (e, msg) {
        this._log(e, msg, 'js-onerror');
    };

    this._log = function (e, msg, logLevel) {
        let errorMsg;

        if (e.message) {
            errorMsg = e.name + ': ' + e.message;
        } else {
            errorMsg = e;
        }

        let payload = {
            eventName: logLevel,
            message: msg + ' ' + errorMsg,
            trace: e.stack || ''
        };

        $(document).trigger('data:scribe', payload);
    };
}

export default defineComponent.component(Logger);


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/utils/logger.js